import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ApiService } from 'src/app/core/services/api.service';
import { IDelibeGlobalService } from 'src/app/core/services/idelibe/global.service';
import { MassGeneration } from 'src/app/shared/models/mass-generation';
import { ModelesDocuments } from 'src/app/shared/models/modelesDocuments.model';
import { Point } from 'src/app/shared/models/point';

@Component({
  selector: 'app-merge-compliant-extracts',
  templateUrl: './merge-compliant-extracts.component.html',
  styleUrls: ['./merge-compliant-extracts.component.scss'],
})
export class MergeCompliantExtractsComponent implements OnInit {
  modelesDocPoint: (ModelesDocuments & { compliantExtract?: boolean })[] = [];
  modele: ModelesDocuments & { compliantExtract?: boolean };
  pointIds: number[] = [];
  errorCount: number = 0;
  errorMessage: string = '';
  successCount: number = 0;
  successMessage: string = '';

  constructor(
    public api: ApiService,
    public IDelibeGlobalService: IDelibeGlobalService,
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    public toastr: ToastrService,
    public router: Router
  ) {}

  ngOnInit(): void {
    this.pointIds = this.config.data.pointIds;
    this.IDelibeGlobalService.getGlobalModelesDoc(null, this.pointIds, false, false, true).subscribe(
      (res: (ModelesDocuments & { compliantExtract?: boolean })[]) => {
        this.modelesDocPoint = this.addCompliantExtractsIfNeeded(res);
      }
    );
  }

  ngOnDestroy(): void {
    this.reinitMessage();
  }

  private addCompliantExtractsIfNeeded(
    res: (ModelesDocuments & { compliantExtract?: boolean })[]
  ): (ModelesDocuments & { compliantExtract?: boolean })[] {
    if (!res.length) return [];

    for (let i = 0; i < res.length; i++) {
      const model = res[i];
      const { isExtrait } = model;

      if (!isExtrait) {
        res[i] = {
          ...model,

          compliantExtract: false,
        } as ModelesDocuments & { compliantExtract: boolean };
        continue;
      }
      const modelCopy = { ...model, description: `↳ ${model.description} - Extrait conforme`, compliantExtract: true };
      res.splice(i + 1, 0, modelCopy);

      //To incrment the index after the insertion
      i++;
    }

    return res;
  }

  onSelectedModel(): void {
    if (!this.modele) return this.reinitMessage();
    this.reinitMessage();
    this.api
      .compliantExtractsbulkGenerationForAPoint({
        seanceId: this.config.data.meetingId,
        modeleId: this.modele.id,
        body: { pointIds: this.pointIds, ConcatExtraitConforme: this.modele.compliantExtract },
      })
      .subscribe((res: MassGeneration[]) => {
        this.createMessageError(res);
      });
  }

  reinitMessage(): void {
    this.errorCount = 0;
    this.successCount = 0;
    this.errorMessage = '';
    this.successMessage = '';
  }

  createMessageError(res: MassGeneration[]): void {
    const idsError: number[] = [];
    const idsSuccess: number[] = [];
    res.forEach(
      (
        element: MassGeneration & {
          hasExtraitConf: boolean;
          extraitConfGeneratedFichierId: number | null;
          extraitConfVersion: number;
        }
      ) => {
        const point = this.config.data.points.find((point: Point) => +point.id === element.pointId);

        if ((!element.extraitConfGeneratedFichierId || !element.hasExtraitConf) && this.modele.compliantExtract) {
          this.errorCount++;
          idsError.push(point.ordreDocs);
        } else if (!element.generated) {
          this.errorCount++;
          idsError.push(point.ordreDocs);
        } else {
          idsSuccess.push(point.ordreDocs);
          this.successCount++;
        }
      }
    );
    this.errorMessage = `<i class="bi bi-exclamation-diamond-fill mr-1"></i> - Le modèle de document sélectionné ne peut pas être fusionné avec les points suivants : ${idsError.sort().join(', ')}`;
    this.successMessage = `<i class="bi bi-check-circle-fill"></i> - Le modèle de document sélectionné peut être fusionné avec les points suivants : ${idsSuccess.sort().join(', ')}`;
  }

  mergeDoc(): void {
    const data = { pointIds: this.pointIds.map((id: number) => +id) };
    this.api.mergeDocuments(this.config.data.meetingId, this.modele.id, data, this.modele.compliantExtract).subscribe({
      next: () => {
        this.toastr.info('Documents en traitement ...', 'Fusion des documents');
        this.ref.close();
      },
      error: () => {
        this.toastr.error('Une erreur est survenue lors de la fusion des documents', 'Fusion des Fusion des documents');
        this.ref.close();
      },
    });
  }
}
